const isPreview = ref(false);

export const useProfilePreviewMode = () => {
  const toggle = () => {
    isPreview.value = !isPreview.value;
  };

  const reset = () => {
    isPreview.value = false;
  };

  return {
    isPreview,
    toggle,
    reset,
  };
};
